import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CurvedDivider } from './CurvedDivider';
const trustPoints = ['Imava veliko veselja do živali', 'Doma imava cel mali živalski vrt, zato sva navajeni različnih ljubljenčkov', 'Do psov pristopava nežno in potrpežljivo', 'Sprehod prilagodiva vsakemu psu', 'Po sprehodu lahko pošljeva slikico', 'Trudiva se, da je pes varen, sproščen in vesel'];
export function Trust() {
  return <div className="relative mt-6" data-id="element-119">
      <CurvedDivider fillColor="#C8E6C9" data-id="element-120" />
      <section className="bg-brand-green-light py-12 md:py-16 px-6" data-id="element-121">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row gap-10 items-center" data-id="element-122">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="w-full md:w-1/2" data-id="element-123">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-text mb-6" data-id="element-124">
              Zakaj nama lahko zaupate
            </h2>
            <ul className="space-y-4" data-id="element-125">
              {trustPoints.map((point, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.15
            }} className="flex items-start gap-3" data-id="element-126">
                  <CheckCircle2 className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5 fill-white" data-id="element-127" />
                  <span className="text-lg text-brand-text font-medium" data-id="element-128">
                    {point}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="w-full md:w-1/2 relative" data-id="element-129">
            <div className="aspect-[4/3] rounded-[3rem] overflow-hidden shadow-lg border-8 border-white/50" data-id="element-130">
              <img src="https://images.unsplash.com/photo-1494947665470-20322015e3a8?auto=format&fit=crop&w=800&q=80" alt="Pes na sprehodu" className="w-full h-full object-cover" data-id="element-131" />
            </div>
          </motion.div>
        </div>
      </section>
      <CurvedDivider fillColor="#C8E6C9" flip className="rotate-180" data-id="element-132" />
    </div>;
}